import request from '../../utils/request';
import {baseDomain} from '../baseDomain'

// 获取新闻分类
export const selectArticleCat = query => {
    return request({
        url: `${baseDomain}/uccn/article/selectArticleCat`,
        method: 'post',
        data: query
    });
};
